import { useState } from "react";
import { Outlet, Navigate } from "react-router-dom";
import { Sidebar } from "@/components/layout";
import { ToastProvider } from "@heroui/toast";
import { useUser } from "@/context";
import { Button } from "@heroui/react";
import { LuMenu } from "react-icons/lu";
import { LOGO_URL } from "@/constants";

import { routes } from "@/routes";

const AdminLayout = () => {
    // Subscribe to user context to trigger re-renders on auth state changes (e.g. logout)
    useUser();

    const isAuthenticated = localStorage.getItem("is_logged_in") === "true";

    if (!isAuthenticated) {
        return <Navigate to="/login" replace />;
    }

    const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
    const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

    return (
        <div className="bg-default-50 flex min-h-screen min-w-0 dark:bg-zinc-800">
            <ToastProvider placement="top-right" toastOffset={10} />

            {/* Mobile Navbar */}
            <nav className="bg-white/80 dark:bg-zinc-900/80 fixed top-0 left-0 right-0 z-30 flex h-14 items-center gap-3 border-b border-zinc-200 px-4 backdrop-blur-md lg:hidden dark:border-zinc-800">
                <Button
                    isIconOnly
                    size="sm"
                    variant="light"
                    onPress={() => setIsMobileSidebarOpen(true)}
                >
                    <LuMenu size={20} />
                </Button>
                <img
                    src={LOGO_URL}
                    alt="Mansoer Group"
                    className="h-7 object-contain"
                />
            </nav>

            {/* Sidebar */}
            <Sidebar
                menuItems={routes}
                isCollapsed={isSidebarCollapsed}
                toggleSidebar={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
                isMobileOpen={isMobileSidebarOpen}
                onMobileClose={() => setIsMobileSidebarOpen(false)}
            />

            {/* Main Content Area */}
            <div
                className={`flex min-w-0 flex-1 flex-col transition-[padding-left] duration-300 ${
                    isSidebarCollapsed ? "lg:pl-18" : "lg:pl-64"
                }`}
            >
                <main className="min-w-0 flex-1 p-4 pt-18 lg:p-6 lg:pt-6">
                    <Outlet />
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
